/** Контент лендинга `/use-cases/online-timer-for-education` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const EDUCATION_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'УРОКИ, ЗАНЯТИЯ, ЭКЗАМЕНЫ',
  heroLead:
    'Онлайн-таймер для урока и занятий: ученики видят, сколько осталось до конца, а учитель держит расписание. Небольшие классы ведите бесплатно — всё работает в браузере.',
  heroNote: 'Без регистрации. Работает в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer помогает держать время урока, когда важно, чтобы и учитель, и ученики видели остаток.',
    items: [
      {
        title: 'Расписание занятий',
        text: 'Таймер на каждый урок или пару: видно остаток до конца, и учитель, и класс держат темп.',
      },
      {
        title: 'Задания и активности',
        text: 'Тесты, групповая работа и выступления учеников — отдельный таймер на каждое задание.',
      },
      {
        title: 'Экзамены и контрольные',
        text: 'Один экран таймера выводится на дисплеи класса — у всех одинаковый отсчёт.',
      },
    ],
  },

  share: {
    title: 'Просто запустить и легко поделиться',
    paragraphs: [
      'preztimer — таймер с удалённым управлением: запуск, пауза и сброс с любого устройства в браузере. Экран таймера и панель управления открываются по ссылке.',
      'Ученики могут открыть экран таймера на своих телефонах, планшетах или ноутбуках по ссылке или QR-коду — и видеть тот же отсчёт, что и на экране в классе.',
    ],
  },

  cloud: {
    title: 'Покажите таймер на любом экране класса',
    lead:
      'Экран таймера — это просто веб-ссылка. Выведите его на проектор, отдельный монитор или устройство учеников.',
    bullets: [
      'ноутбук + проектор по HDMI, экран таймера в полноэкранном режиме;',
      'планшет, ТВ-приставка или отдельный монитор — любая ссылка в браузере;',
      'для онлайн- и гибридных уроков — показ экрана в Zoom или Teams.',
    ],
  },

  communication: {
    title: 'Отдельные комнаты под расписание, активности и экзамены',
    lead:
      'Создайте свою комнату под каждую задачу: расписание дня — в одной, гибкие таймеры занятия — в другой.',
    bullets: [
      'расписание дня — таймеры на каждый урок и пару;',
      'гибкие таймеры на упражнения, обсуждения и доклады;',
      'экзамен — один экран таймера сразу на нескольких дисплеях класса.',
    ],
  },

  modes: {
    title: 'Гибкое управление во время урока',
    lead:
      'Запускайте, ставьте на паузу и корректируйте время во время урока — фокус на занятии, а не на таймере.',
    bullets: [
      'обратный отсчёт, секундомер или часы (время суток);',
      'плановое время старта для уроков и пар;',
      'быстрые кнопки добавляют или убавляют время, перерасход виден как +00:01.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Небольшие классы ведите бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: доклады и выступления',
    lead:
      'Доклад ученика, защита проекта или питч — отдельная страница с акцентом на регламент одного выступления.',
    to: '/use-cases/presentations',
    linkLabel: 'Таймер для презентаций и докладов',
  },

  faqSectionTitle: 'Частые вопросы о таймере для урока',
  faqItems: [
    {
      question: 'Нужно ли что-то устанавливать?',
      answer:
        'Нет. preztimer работает в любом современном браузере — Chrome, Firefox, Safari или Edge. Откройте сайт, создайте таймер и выведите его на экран. Для быстрого урока подойдёт гостевая комната без регистрации.',
    },
    {
      question: 'Увидят ли ученики таймер на своих устройствах?',
      answer:
        'Да. Поделитесь ссылкой или QR-кодом на экран таймера — ученики откроют его на телефоне, планшете или ноутбуке и увидят тот же отсчёт, которым вы управляете с компьютера.',
    },
    {
      question: 'Подходит ли для онлайн- и гибридных уроков?',
      answer:
        'Да. Покажите экран таймера через демонстрацию экрана в Zoom, Teams или другом сервисе видеосвязи — удалённые ученики будут видеть тот же отсчёт, что и класс.',
    },
    {
      question: 'Можно ли использовать на экзаменах и тестах?',
      answer:
        'Да. Откройте один экран таймера на нескольких дисплеях класса — у всех будет одинаковый отсчёт. Для разных аудиторий можно создать отдельные комнаты.',
    },
    {
      question: 'Нужна ли регистрация?',
      answer:
        'Нет. Для разовых занятий создайте гостевую комнату без аккаунта. Аккаунт нужен, чтобы сохранять комнаты и расписание между уроками.',
    },
    {
      question: 'Сколько таймеров можно создать?',
      answer:
        'На Базовом — до 3 таймеров в комнате и до 3 комнат на аккаунт. На Профи — до 50 таймеров в комнате и без лимита комнат, удобно для расписания на весь день или семестр.',
    },
  ],
};
